module.exports = __webpack_public_path__ + "media/seeYouSoon2.ae3f6631.mp3";